module.exports = __webpack_public_path__ + "img/behold-6.dbfe0758.png";